import React, { Component } from 'react';
import { bindActionCreators, compose } from 'redux';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { Col, Container, Row, Card, CardBody, Button } from 'reactstrap';
// import { LoadPage, ShowSpinner } from '../../redux/SqlReport';
// import { showNotification } from '../../redux/Notification';
import { changeBlogTag } from '../../redux/CmnBlog';
import { GetBlogList, GetBlogTagList } from '../../services/CmnBlogService';
import Paging from '../../components/custom/Paging';
import { toBlogDateFormat, toDate } from '../../helpers/formatter';
import LoadingIcon from 'mdi-react/LoadingIcon';
import log from '../../helpers/logger';
import MetaTags from 'react-meta-tags';
// import {Helmet} from "react-helmet";
import Skeleton, { SkeletonTheme } from "react-loading-skeleton";

class BlogList extends Component {
  constructor(props) {
    super(props);
    const blogTagId = this.props.CmnBlog.blogTagId || 0;

    this.state = {
      limit: 5,
      blogList: [],
      pageOfItems: [],
      blogAmount: 0,
      blogTagList: [],
      activeId: blogTagId,
      loading: true
    }

    this.onChangePage = this.onChangePage.bind(this);
    this.onTagChange = this.onTagChange.bind(this);
    this.onLoadMore = this.onLoadMore.bind(this);
    this.loadBlogList(blogTagId, []);


    GetBlogTagList().then(
      (resp) => {
        this.setState({
          blogTagList: resp.data.data
        });
      },
      (error) => {
        console.log(error);
      }
    )
  }

  onChangePage(pageOfItems) {
    console.log(pageOfItems);
    // update state with new page of items
    this.setState({ pageOfItems: pageOfItems });
  }

  onTagChange(blogTagId) {
    if (this.state.activeId === blogTagId) return;
    this.setState({ activeId: blogTagId, loading: true, limit: 5 });

    this.loadBlogList(blogTagId, []);
  }

  loadBlogList(blogTagId, currentList) {
    GetBlogList(this.state.limit, currentList.length, blogTagId).then(
      (resp) => {
        this.setState({
          blogList: [...currentList, ...resp.data.data],
          blogAmount: resp.data.data.length,
          loading: false
        });
      },
      (error) => {
        console.log(error);
      }
    )
  }

  componentDidMount() {
    document.title = "FintruX Blog List";
    // console.log(this.props.CmnBlog.blogTagId);
    // GetBlogList(0, 0, this.props.CmnBlog.blogTagId ? this.props.CmnBlog.blogTagId : 0).then(
  }

  componentDidUpdate(prevprops, prevstates) {
  }

  onLoadMore() {
    // console.log(this.state.limit);
    // this.setState({
    //     limit: this.state.limit + 5
    // });
    this.loadBlogList(this.state.activeId, this.state.blogList);

  }

  render() {
    const blogList = this.state.blogList;
    const pageOfItems = this.state.pageOfItems;
    const blogTagList = this.state.blogTagList;
    return (
      <Container className="mt-60">
        {/* <Row>
          <Col md={12}>
            <MetaTags>
              <meta property="og:title" content="FintruX Blog List" />
              <meta property="og:description" content="Read Latest Fintrux Blogs" />
              <meta property="og:image" content="http://blog.fintrux.com/metaImg.jpg" />
              <meta property="og:url" content="http://blog.fintrux.com" />
              <meta name="twitter:card" content="summary_large_image" />
              <meta name="twitter:title" content="FintruX Blog List" />
              <meta name="twitter:description" content="Read Latest Fintrux Blogs" />
              <meta name="twitter:image" content="http://blog.fintrux.com/metaImg.jpg" />
              <meta name="twitter:site" content="http://blog.fintrux.com" />
            </MetaTags>
          </Col>
        </Row> */}
        <Row>
          <Col md={12}>
            <h3 className='page-title'>FintruX Blog List</h3>
            {/* <h3 className='page-subhead subhead'>The P2P Lending Ecosystem Powered by Blockchain and No-Code Development.</h3> */}
          </Col>
        </Row>
        <Row>
          <Col md={12} lg={7} xl={8}>
            {/* <h4 className='subhead'>Found {this.state.blogAmount} results</h4> */}
            <div>
              <div className="blogTagContainer">
                <Button className={"btn outline btn-sm " + (0 === this.state.activeId ? "selected" : "")} onClick={() => { this.onTagChange(0) }}>All</Button>
                {blogTagList.map((item, i) => {
                  return <Button key={i} onClick={() => { this.onTagChange(item.BlogTagId) }} className={"btn outline btn-sm " + (item.BlogTagId === this.state.activeId ? "selected" : "")}>{item.BlogTagName}</Button>
                }
                )}
              </div>
            </div>
            <div>
              {this.state.loading === true && <div>
                <div className="BLogListContainer">
                  <Row>
                    <Col md={4} lg={4}><h1><Skeleton /></h1></Col>
                    <Col md={8} lg={8}><Skeleton count={5} /></Col>
                  </Row>
                </div>
                <div className="BLogListContainer">
                  <Row>
                    <Col md={4} lg={4}><h1><Skeleton /></h1></Col>
                    <Col md={8} lg={8}><Skeleton count={5} /></Col>
                  </Row>
                </div>
                <div className="BLogListContainer">
                  <Row>
                    <Col md={4} lg={4}><h1><Skeleton /></h1></Col>
                    <Col md={8} lg={8}><Skeleton count={5} /></Col>
                  </Row>
                </div>
              </div>}
              {/* {this.state.loading === false && pageOfItems.map((item, i) => { */}
              {this.state.loading === false && blogList.map((item, i) => {
                return <div className="BLogListContainer" key={i}>
                  <Row>
                    <Col md={4} lg={4}>
                      {/* <div className="imageSec"> */}
                      <div>
                        <img className="mt-15" src={item.PicMed ? ("data:application/base64;base64," + item.PicMed) : (require('../../img/DefaultBLogImg.jpg'))} alt='catalog-item-img' />
                      </div>
                    </Col>
                    <Col md={8} lg={8}>
                      <div className='search-result' >
                        <div className="alignSec">
                          <div className="alignLeft">
                            <h5 className="pastBLogDate">{toBlogDateFormat(item.BlogDate)}</h5>
                          </div>
                          <div className="alignRight">
                            {
                              item.BlogTagName ?
                                (<span className="blogTagDisplay">{item.BlogTagName}</span>) : null
                            }
                          </div>
                          <div className="alignClear"></div>
                        </div>
                        <h4>
                          <Link className="link" to={'/BlogDtl/' + item.BlogId + '/' + item.BlogTitle.split(' ').join('')} >
                            <span className="underlineThin">
                              {item.BlogTitle}</span>
                          </Link>
                        </h4>
                        <div><span className="blogHeader">{item.BlogHeader}</span></div>
                        <p className='search-result__preview'>{item.BlogDesc}</p>
                        <p className="viewMoreBtn"><Link className="link" to={'/BlogDtl/' + item.BlogId + '/' + item.BlogTitle.split(' ').join('')} >Read More...</Link></p>
                      </div>
                    </Col>
                  </Row>
                </div>
              }
              )}
            </div>
            <div className="loadMoreBtnSec">
              {this.state.blogAmount >= this.state.limit && <div className="btnSec">
                <a className="btn outline btn-sm btn btn-secondary loadMoreBtn" onClick={this.onLoadMore}>Load More</a>
              </div>}
            </div>
            {/* <Paging items={blogList} onChangePage={this.onChangePage} pageSize={5} initialPage={1} /> */}
          </Col>
          <Col md={12} lg={1} xl={1}></Col>
          <Col md={12} lg={4} xl={3}>
            <div className="aboutUsSec mb-40">
              <h3>ABOUT US</h3>
              <p className="blogDesc">FintruX Network innovates smart solutions for underserved startups and SMEs. We aim to be the one-stop resource and solution provider for business growth and sustainability.</p>
              {/* <p className="blogDesc">Find us on our:  <a target="_blank" href="https://www.fintrux.com/">Website</a>; <a target="_blank" href="https://twitter.com/fintrux/">Twitter</a>; <a target="_blank" href="https://www.facebook.com/fintrux">Facebook</a>; <a target="_blank" href="https://www.reddit.com/r/fintrux">Reddit</a>;  <a target="_blank" href="https://www.linkedin.com/company/fintrux/">LinkedIn</a></p> */}
              <p className="blogDesc">Find us on our:</p>

              <div>
                <ul className="social">
                  
                  <li className="animated fadeInUp"><a href="https://t.me/FintruX" target="_blank"><em className="fa fa-telegram"></em></a></li>
                  <li className="animated fadeInUp"><a href="https://twitter.com/fintrux" target="_blank"><em className="fa fa-twitter"></em></a></li>
                  <li className="animated fadeInUp"><a href="https://www.facebook.com/fintrux" target="_blank"><em className="fa fa-facebook"></em></a></li>
                  <li className="animated fadeInUp"><a href="https://www.youtube.com/c/FintruX" target="_blank"><em className="fa fa-youtube"></em></a></li>
                  <li className="animated fadeInUp"><a href="https://www.instagram.com/FintruX.Network/" target="_blank"><em className="fa fa-instagram"></em></a></li>
                  <li className="animated fadeInUp"><a href="https://www.linkedin.com/company/fintrux/" target="_blank"><em className="fa fa-linkedin"></em></a></li>
                  <li className="animated fadeInUp"><a href="https://www.medium.com/FintruX" target="_blank"><em className="fa fa-medium"></em></a></li>
                </ul>
              </div>
            </div>
            <div>
            </div>

          </Col>
        </Row>
      </Container>
    );
  };
};

const mapStateToProps = (state) => ({
  // user: state.user,
  // error: state.error,
  CmnBlog: state.CmnBlog
});

const mapDispatchToProps = (dispatch) => (
  bindActionCreators(Object.assign({},
    // {LoadPage: LoadPage },
    // {showNotification: showNotification },
    { changeBlogTag: changeBlogTag }

  ), dispatch)
)

export default connect(mapStateToProps, mapDispatchToProps)(BlogList);





// WEBPACK FOOTER //
// ./src/pages/CmnBlog/BlogList.js